// import { Options } from "../../../../utils/Options";

export const FormFields = {
  Privacy_Statement_Checkbox: {
    type: "checkbox",
    id: "privacy-statement-checkbox",
    name: "privacyStatementCheckbox",
    labelId: "privacy-statement",
    label: `Yes, I acknowledge that I have read and consent to Guardian’s
        Online Terms and Conditions of Use, Guardian’s Privacy
        Statement and Guardian’s agreement to conduct business
        electronically.`,
    formsControlId: "checkbox-forms-id-1",
    ariaDescribedBy: "privacy-statment-error-message",
    validation: {
      required: {
        message: "Please acknowledge to continue",
      },
    },
  },
  Arbitration_Clause_Checkbox: {
    type: "checkbox",
    id: "arbitration-clause-checkbox",
    name: "arbitrationClauseCheckbox",
    labelId: "arbitration-clause",
    label: `Yes, I acknowledge that Guardian’s Online Terms and Conditions
    of Use contain a binding arbitration clause.`,
    formsControlId: "checkbox-forms-id-2",
    ariaDescribedBy: "arbitration-clause-error-message",
    validation: {
      required: {
        message: "Please acknowledge to continue",
      },
    },
  },
};
